import PropTypes from 'prop-types';

import { useClickstreamCallback } from '@zenbusiness/application-commons-clickstream';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import { useTheme } from '@zenbusiness/zui/styles';

import * as Styled from './WidgetLink.style';

function WidgetLink({ text, url, eventProps, icon }) {
  const theme = useTheme();
  const handleLinkPressed = useClickstreamCallback('linkPressed', {
    elementAsset: 'arrow-sm-right-outline.svg',
    elementName: 'section_link',
    pageCategory: 'dashboard',
    elementText: text,
    linkDestination: url,
    ...eventProps,
  });

  return (
    <Styled.Link onClick={handleLinkPressed} to={url}>
      {text}
      <SharedAsset
        alt=""
        color={theme.palette.text.tertiary}
        src={icon ?? '/s2/icon/arrow-sm-right-outline.svg'}
        width={24}
      />
    </Styled.Link>
  );
}

WidgetLink.propTypes = {
  /** Text content to display in the link */
  text: PropTypes.string.isRequired,
  /** URL to navigate to when the link is clicked */
  url: PropTypes.string.isRequired,
  /** Additional properties to include in the clickstream event tracking */
  eventProps: PropTypes.shape({}),
  /** Icon source to display in the link */
  icon: PropTypes.string,
};

export default WidgetLink;
